import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { PersonalizeLayout } from "../view/PersonalizeLayout";
import emitter from "@utils/emitter";
import { WAIT_DELAY } from "./RetryGuard";

const Skeleton = dynamic(() => import("react-loading-skeleton"), {
    ssr: false,
});

export const GameplaySkeleton = (props: any) => {
    const { retry = true } = props;

    useEffect(() => {
        if (!retry) return;
        let interval = setTimeout(() => {
            if (typeof window === "undefined") return;
            emitter.emit("show_retry_popup", {
                source: "gameplay_skeleton",
                id: props.id ?? "",
            });
        }, WAIT_DELAY);

        return () => {
            if (interval) {
                clearTimeout(interval);
                // @ts-ignore
                interval = null;
            }
        };
    }, []);

    return (
        <PersonalizeLayout>
            <div className="flex w-i flex-col">
                <Skeleton width={"100%"} height={"56px"} className="mb-3 " />
                <div className="my-4 flex flex-row items-center justify-center">
                    <Skeleton height={"33px"} width="250px" />
                </div>
                <div className="mb-8 px-4">
                    <Skeleton height={"80vh"} />
                </div>
            </div>
        </PersonalizeLayout>
    );
};
